<template>
    <v-card class="elevation-1">
        <v-toolbar flat height="37">
            <span class="primary--text font-weight-bold">
                MY APPROVALS
            </span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-data-table
            :headers="isMobile ? header_mobile : header"
            :items="approvalInbox"
            :loading="loading"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="paginationSync"
        >
            <template v-slot:items="props">
                <tr @click="viewDetails(props.item)" class="clickable" :title="`Click to view ${props.item.requestType} details`">
                    <td>
                        <v-chip class="user-chip-container">
                            <v-avatar>
                                <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.requestedBy.userId)"></v-img>
                            </v-avatar>
                            {{props.item.requestedBy.firstName}} {{props.item.requestedBy.lastName}}
                        </v-chip>
                    </td>
                    <td>{{ props.item.requestType }}</td>
                    <td>
                        {{ formatCreatedDate(props.item.updatedOn) }}
                    </td>
                    <td v-if="!isMobile">
                        <span :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</span>
                    </td>
                </tr>
            </template> 
        </v-data-table>
    </v-card>
</template>

<script>

import approvalInboxApi from '@/api/approvalinbox'
import awsS3Helper from '@/helpers/aws-s3'
import commonfn from '@/common/functions'       //for refactor
import rowsPerPageItems from '@/constants/rows-per-page'
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort } from '@/helpers/user-prefs'
import { formatCreatedDate } from '@/helpers/date-helpers'

const ROUTE_MAP = {
    'ATTENDANCE_CORRECTION': '/myteam/corrections/details/',
    'TIME_OFF': '/myteam/timeoff/details/',
    'OVERTIME': '/myteam/overtime/details/',
    'REIMBURSEMENT': '/finance/reimbursements/',
    'CASH_ADVANCE': '/finance/cashadvances/',
    'LOAN_PAYMENT': '/finance/loans/'
};

export default {     
    name: 'MyApprovals',
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            rowsPerPageItems,
            awsS3Helper,
            commonfn,
            formatCreatedDate,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            header: [
                {text:'Requested By', align:'left', width:'35%', value:'lastName', sortable:true},
                {text:'Type', align: 'left', width:'25%', value:'requestType', sortable:true},
                {text:'Requested On', align: 'left', width:'20', value:'updatedOn', sortable:true},
                {text:'Status', align: 'left', width:'20%', value:'status', sortable:true},
            ],
            header_mobile: [
                {text:'Requested By', align:'left', width:'25%', value:'lastName', sortable:true},
                {text:'Type', align: 'left', width:'25%', value:'requestType', sortable:true},
                {text:'Date', align: 'left', width:'25%', value:'updatedOn', sortable:true}
            ],
            error: false,
            errorMessage: '',
            loading: false,
            approvalInbox: []
        }
    },
    methods: {
        viewDetails(data) {
            if (data.requestTypeCode === 'TIMESHEET') {
                return this.$router.push(`/myteam/timesheet/${data.cutoffId}/${data.requestedBy.userId}`);
            }

            const baseRoute = ROUTE_MAP[data.requestTypeCode];
            if (baseRoute) {
                this.$router.push(`${baseRoute}${data.requestId}`);
            }
        },
        async getMyApprovals() {
            try {
                this.loading = true
                const response = await approvalInboxApi.getMyApprovals()
                if (response && response.status == 200) {
                    this.approvalInbox = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    created() {
        this.getMyApprovals()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
}
</script>